import {redirect, useLoaderData, useParams} from "react-router-dom";
import HttpRequest from "../../services/Request";
import TournamentComponent from '../../components/Tournament'
import UserBox from "../../components/UserBox";
import Cookies from "js-cookie";
import BackButton from "../../components/BackButton";

const Post = () => {
    const {tournament, posts} = useLoaderData();
    const params = useParams();
    return <div>
        <BackButton src={`/tournament/${params.id}`}/>
        <div className="flex items-center">
            <TournamentComponent tournament={tournament}/>
        </div>
        <div className="flex items-center mt-2">
            <div className="flex flex-wrap w-[97%]  md:w-[90%] rounded-[15px]  mx-auto mt-1 md:mt-0 md:mb-2 p-2 py-5">
                <div className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange">
                    <img src="/icons/icon-4.png" className="inline me-3 w-[25px] h-[25px]"/>
                    مدیریت نفرات تیم
                </div>
            </div>
        </div>
        <div className="flex items-center mt-2">
            <div
                className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">
                {posts.map((post, index) => {
                    return <UserBox key={index} post={post}/>
                })}
            </div>
        </div>
    </div>
}

export default Post

export async function PostPageLoader({params}) {
    let data = []
    try {
        await HttpRequest(`${process.env.REACT_APP_DOMAIN}/tournament/${params.id}/team/posts`, (res) => {
                data = res.data;
            }, 'get', [], (err) => {
                let error = new Error();
                error.status = err.response.status
                throw error
            }
        )
    } catch (err) {
        if (err.status === 401) {
            Cookies.remove('access_token')
            return redirect('/login')
        }
    }
    return data;
}